import React from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLandmark, faHistory, faTasks, faDownload, faBuilding, faMapMarkedAlt, faUsers, faIdCard } from '@fortawesome/free-solid-svg-icons';
import doc from './../../assets/RSBhistory.pdf';
import footerBg from "./../../assets/footerbg.jpg";
const Introduction = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin:'2%',
        borderRadius:'10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faLandmark} className="me-2" />
            Introduction
          </h3>
        </Container>
      </div>
      
      <Container className="py-5">
        {/* Quick Stats Cards */}
        <Row className="mb-5">
          <Col md={4} className="mb-3">
            <div className="text-center p-4" style={{
              background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
              borderRadius: '16px',
              color: 'white',
              boxShadow: '0 8px 25px rgba(30,60,114,0.3)'
            }}>
              <FontAwesomeIcon icon={faBuilding} style={{fontSize: '2.5rem', marginBottom: '15px'}} />
              <h4 className="fw-bold mb-1">22</h4>
              <small style={{opacity: 0.9}}>District Offices</small>
            </div>
          </Col>
          <Col md={4} className="mb-3">
            <div className="text-center p-4" style={{
              background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
              borderRadius: '16px',
              color: 'white',
              boxShadow: '0 8px 25px rgba(22,160,133,0.3)'
            }}>
              <FontAwesomeIcon icon={faMapMarkedAlt} style={{fontSize: '2.5rem', marginBottom: '15px'}} />
              <h4 className="fw-bold mb-1">7,356</h4>
              <small style={{opacity: 0.9}}>Villages Covered</small>
            </div>
          </Col>
          <Col md={4} className="mb-3">
            <div className="text-center p-4" style={{
              background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
              borderRadius: '16px',
              color: 'white',
              boxShadow: '0 8px 25px rgba(142,68,173,0.3)'
            }}>
              <FontAwesomeIcon icon={faUsers} style={{fontSize: '2.5rem', marginBottom: '15px'}} />
              <h4 className="fw-bold mb-1">2017</h4>
              <small style={{opacity: 0.9}}>Established Year</small>
            </div>
          </Col>
        </Row>
        
        {/* About Section */}
        <Row className="mb-4">
          <Col lg={12}>
            <Card className="border-0" style={{borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)'}}>
              <div style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                padding: '30px',
                color: 'white'
              }}>
                <h3 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faLandmark} className="me-2" />
                  About the Department
                </h3>
              </div>
              <CardBody className="p-5">
                <p style={{color: '#495057', lineHeight: '1.9', fontSize: '1.05rem'}}>
                  Government of Haryana has created Directorate of Sainik and Ardh Sainik Welfare in the year 2017 vide Gazette notification No.6/5/2016-cabinet dated 27 Dec 2016. Erstwhile it was known as Rajya Sainik Board. The department has been created by considering the requirement of Serving & Veteran of all Defence services and Central Armed Police Forces and their Dependents. State of Haryana has 22 districts and 7356 villages and is the seventeenth most populous state. Every district of Haryana has an enormous strength of Ex-servicemen and their dependents.
                </p>
                <p style={{color: '#495057', lineHeight: '1.9', fontSize: '1.05rem'}}>
                 State Government has initiated and promulgated various policies and welfare-related programs for the benefits of retired veterans and serving personnel of Armed Forces and Central Armed Police Forces and exercises control and supervision over the 22 Districts through its District Sainik & Ardh Sainik Welfare Offices within the State of Haryana. The Department also ensures the implementation of e-governance.
                </p>
                 <a 
                  className="btn mt-4" 
                  href={doc} 
                  target='_blank' 
                  rel="noopener noreferrer" 
                  download="RSB history.pdf"
                  style={{
                    background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                    color: 'white',
                    borderRadius: '12px',
                    padding: '14px 30px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    boxShadow: '0 4px 15px rgba(30,60,114,0.3)',
                    display: 'inline-flex',
                    alignItems: 'center'
                  }}
                >
                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                  Download History PDF
                </a>
              </CardBody>
            </Card>
          </Col>
        </Row>
        
        {/* History Section */}
        <Row className="mb-4">
          {/* <Col lg={8}>
            <Card className="h-100 border-0" style={{borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(22,160,133,0.15)'}}>
              <div style={{
                background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                padding: '30px',
                color: 'white'
              }}>
                <h3 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faHistory} className="me-2" />
                  History of Directorate
                </h3>
              </div>
              <CardBody className="p-5">
                <p style={{color: '#495057', lineHeight: '1.9', fontSize: '1.05rem'}}>
                  Government of Haryana has created Directorate of Sainik and Ardh Sainik Welfare in the year 2017 vide Gazette notification No.6/5/2016-cabinet dated 27 Dec 2016. Erstwhile it was known as Rajya Sainik Board. The department has been created by considering the requirement of Serving & Veteran of all Defence services and Central Armed Police Forces and their Dependents. State of Haryana has 22 districts and 7356 villages and is the seventeenth most populous state. Every district of Haryana has an enormous strength of Ex-servicemen and their dependents.
                </p>
                <p style={{color: '#495057', lineHeight: '1.9', fontSize: '1.05rem'}}>
                  State Government has initiated and promulgated various policies and welfare-related programs for the benefits of retired veterans and serving personnel of Armed Forces and Central Armed Police Forces and exercises control and supervision over the 22 Districts through its District Sainik & Ardh Sainik Welfare Offices within the State of Haryana. The Department also ensures the implementation of e-governance.
                </p>
                <a 
                  className="btn mt-4" 
                  href={doc} 
                  target='_blank' 
                  rel="noopener noreferrer" 
                  download="RSB history.pdf"
                  style={{
                    background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                    color: 'white',
                    borderRadius: '12px',
                    padding: '14px 30px',
                    textDecoration: 'none',
                    fontWeight: '600',
                    boxShadow: '0 4px 15px rgba(30,60,114,0.3)',
                    display: 'inline-flex',
                    alignItems: 'center'
                  }}
                >
                  <FontAwesomeIcon icon={faDownload} className="me-2" />
                  Download History PDF
                </a>
              </CardBody>
            </Card>
          </Col> */}
          
          <Col lg={12}>
            <Card className="h-100 border-0" style={{borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(142,68,173,0.15)'}}>
              <div style={{
                background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                padding: '30px',
                color: 'white'
              }}>
                <h5 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faTasks} className="me-2" />
                  Key Facts
                </h5>
              </div>
              <CardBody className="p-4">
                <ul style={{color: '#495057', fontSize: '1rem', lineHeight: '2', paddingLeft: '20px'}}>
                  <li>17th most populous state</li>
                  <li>22 District offices operational</li>
                  <li>7,356 villages covered</li>
                  <li>E-governance implementation</li>
                  <li>Central & State coordination</li>
                  <li>Welfare schemes administration</li>
                </ul>
              </CardBody>
            </Card>
          </Col>
        </Row>
        
        {/* Activities Section */}
        <Row>
          <Col lg={12}>
            <Card className="border-0" style={{borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)'}}>
              <div style={{
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                padding: '30px',
                color: 'white'
              }}>
                <h3 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faTasks} className="me-2" />
                  Department Activities
                </h3>
              </div>
              <CardBody className="p-5">
                <Row>
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        marginRight: '20px',
                        flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(30,60,114,0.3)'
                      }}>
                        1
                      </div>
                      <p className="mb-0" style={{color: '#495057', lineHeight: '1.7', fontSize: '1rem'}}>
                       Coordinating the work of DSASWD (District Sainik and Ardh Sainik Welfare Department) in Haryana State.
                      </p>
                    </div>
                  </Col>
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div style={{
                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        marginRight: '20px',
                        flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(22,160,133,0.3)'
                      }}>
                        2
                      </div>
                      <p className="mb-0" style={{color: '#495057', lineHeight: '1.7', fontSize: '1rem'}}>
                        Promoting measures for the welfare and resettlement of Ex-servicemen and families of serving/deceased personnel of the Armed Forces.
                      </p>
                    </div>
                  </Col>
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div style={{
                        background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        marginRight: '20px',
                        flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(142,68,173,0.3)'
                      }}>
                        3
                      </div>
                      <p className="mb-0" style={{color: '#495057', lineHeight: '1.7', fontSize: '1rem'}}>
                       Disseminating information to the general public regarding the Armed Forces in the Country and taking measures to rouse intelligent interest in the general public.
                      </p>
                    </div>
                  </Col>
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        marginRight: '20px',
                        flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(30,60,114,0.3)'
                      }}>
                        4
                      </div>
                      <p className="mb-0" style={{color: '#495057', lineHeight: '1.7', fontSize: '1rem'}}>
                        Administering the DSASWD in Haryana State in accordance with the Rules and instructions prescribed by the Central and State Governments.
                      </p>
                    </div>
                  </Col>
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div style={{
                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        marginRight: '20px',
                        flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(22,160,133,0.3)'
                      }}>
                        5
                      </div>
                      <p className="mb-0" style={{color: '#495057', lineHeight: '1.7', fontSize: '1rem'}}>
                        Holding meetings of Haryana DSASWD and pursuing its recommendations with the Government for acceptance in the interest of serving/ESM and their dependents.
                      </p>
                    </div>
                  </Col>
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div style={{
                        background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        marginRight: '20px',
                        flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(142,68,173,0.3)'
                      }}>
                        6
                      </div>
                      <p className="mb-0" style={{color: '#495057', lineHeight: '1.7', fontSize: '1rem'}}>
                        Maintaining the accounts of Haryana DSR Fund and Amalgamated Fund and implementing the decisions of Fund Committees.
                      </p>
                    </div>
                  </Col>
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        marginRight: '20px',
                        flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(30,60,114,0.3)'
                      }}>
                        7
                      </div>
                      <p className="mb-0" style={{color: '#495057', lineHeight: '1.7', fontSize: '1rem'}}>
                        Holding meetings of DSRF/AMLF Committees.
                      </p>
                    </div>
                  </Col>
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div style={{
                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        marginRight: '20px',
                        flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(22,160,133,0.3)'
                      }}>
                        8
                      </div>
                      <p className="mb-0" style={{color: '#495057', lineHeight: '1.7', fontSize: '1rem'}}>
                        Collection of funds towards Flag Day Fund.
                      </p>
                    </div>
                  </Col>
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div style={{
                        background: 'linear-gradient(135deg, #8e44ad 0%, #9b59b6 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        marginRight: '20px',
                        flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(142,68,173,0.3)'
                      }}>
                        9
                      </div>
                      <p className="mb-0" style={{color: '#495057', lineHeight: '1.7', fontSize: '1rem'}}>
                        Setting up and running various vocational training centers / Career Guidance Courses etc. for imparting training to war widows, widows of ESM, dependents of war widows, and widows of ESM, dependents of serving/ESM and ESM in various trades for their rehabilitation.
                      </p>
                    </div>
                  </Col>
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        marginRight: '20px',
                        flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(30,60,114,0.3)'
                      }}>
                        10
                      </div>
                      <p className="mb-0" style={{color: '#495057', lineHeight: '1.7', fontSize: '1rem'}}>
                        Preparing Budget in respect of Schemes being run out of Government funds and placing the same at the disposal of concerned authorities for implementation.
                      </p>
                    </div>
                  </Col>
                  <Col md={6} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div style={{
                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                        color: 'white',
                        width: '40px',
                        height: '40px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        marginRight: '20px',
                        flexShrink: 0,
                        boxShadow: '0 4px 10px rgba(22,160,133,0.3)'
                      }}>
                        11
                      </div>
                      <p className="mb-0" style={{color: '#495057', lineHeight: '1.7', fontSize: '1rem'}}>
                        Providing employment to ESM and their dependents.
                      </p>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Introduction;
